import { className, Grid, h, html as htmlGrid } from 'gridjs'
import { URLS } from '../constants/urls.js'
import initTabelaGenericaMixin from '../mixins/initTabelaGenerica.js'

export default {
	mixins: [initTabelaGenericaMixin],
	emits: ['fechar-modal', 'email-selecionado'],
	data() {
		return {
			tableHistoricoEmails: null,
		}
	},
	methods: {
		mapAndFilterSolicitations(data) {
			const lista = data?.results || []
			return lista.map((item) => ({
				ID: item.id,
				Para: item.enviado_para,
				Assunto: item.assunto,
				Enviados: item.enviado_em,
				acao: item, // objeto completo para ações
			}))
		},

		getTotalEmails(data) {
			return data?.count || 0
		},

		formatDataEmail(data) {
			if (!data) return ''
			const d = new Date(data)
			return `${d.toLocaleDateString('pt-BR')} ${d.toLocaleTimeString('pt-BR', {
				hour: '2-digit',
				minute: '2-digit',
			})}`
		},

		renderHistoricoAcoes(row) {
			const tamanhoCell = row?.cells?.length || 0

			if (tamanhoCell === 0) return ''

			const idEmail = row?.cells?.[tamanhoCell - 1]?.data?.id

			if (!idEmail) return ''

			return htmlGrid(
				`<svg 
                        style="width:24px; height:24px; cursor:pointer;" 
                        class="icon-20 icon-neutral-60 btn-ver-email" 
                        title="Visualizar E-mail Enviado"
                        data-id="${idEmail}">
                        <use xlink:href="#icon_search"></use>
                    </svg>`
			)
		},

		onClickSelecionarEmail(idEmail) {
			this.$emit('email-selecionado', idEmail)
		},

		iniciarTabelaHistoricoEmails() {
			const tabela = document.getElementById('tabela-historico-emails')

			if (!tabela) return

			const columns = [
				{ id: 'ID', name: 'ID', hidden: true, width: '100px' },
				{ id: 'Para', name: 'Para', width: '10rem' },
				{ id: 'Assunto', name: 'Assunto', hidden: false },
				{
					id: 'Enviados',
					name: 'Enviados',
					formatter: (cell) => this.formatDataEmail(cell),
				},
				{
					id: 'acao',
					name: '',
					width: '40px',
					formatter: (cell, row) => this.renderHistoricoAcoes(row),
				},
			]

			this.tableHistoricoEmails = this.iniciarTabelaGenerica(
				columns,
				`${window.origin}${URLS.email_enviados}?`,
				(data) => this.mapAndFilterSolicitations(data),
				(data) => this.getTotalEmails(data)
			)

			this.tableHistoricoEmails.render(tabela)

			tabela.addEventListener('click', (e) => {
				const icon = e.target.closest('.btn-ver-email')
				if (icon) {
					const id = icon.getAttribute('data-id')
					this.$emit('email-selecionado', id)
				}
			})
		},

		onClickFecharModal() {
			modal_padrao_vue.closeModal('email_lista_enviados')
			this.$emit('fechar-modal')
		},
	},

	async mounted() {
		this.iniciarTabelaHistoricoEmails()
	},

	template: `
    <section
            class="modal--content rounded-md flex-1 w-full !h-max overflow-[initial] relative"
            data-id="email_lista_enviados"
            data-modal-id="email_lista_enviados">
         <div class="w-full h-full">
		 <header class="flex items-center justify-between w-full px-24 pt-24 pb-16 bg-primary-pure">
                <h2 class="text-lg font-medium text-white">Histórico de E-mail</h2>
                <button 
					type="button" 
					class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10 close-btn"
					@click="onClickFecharModal">
                    <svg class="w-32 h-32">
                        <use xlink:href="#icon_close"></use>
                    </svg>
                </button>
            </header>
             <div
                class="flex flex-col gap-32 mt-16 mb-16 md2:mt-16 md2:mb-0 !mx-auto p-24 !max-h-[400px] !overflow-y-scroll"">
                <div id="tabela-historico-emails"></div>
            </div>
         </div>
    </section>
    `,
}
